module.exports = __webpack_public_path__ + "static/media/rabbithole.36f5e332.png";